<template>
    <div class="page" ref="scroller">
        <div
            v-if="study.adImg"
            class="introBox"
            :style="{
                background: 'url(' + study.adImg + ') no-repeat center/cover',
            }"
        >
            <div class="intro">
                <div class="title">{{ study.title }}</div>
                <div class="desc" v-html="study.pageDes"></div>
                <!-- <div class="updateTime">
                    {{ study.status }}
                </div> -->
                <div class="xupay" v-if="showXufei">
                    <img class="notice" src="~@/assets/notice.png" alt="" />
                    <span>您的阅读权限即将到期，请及时</span>
                    <button @click="goPay">续订</button>
                </div>
            </div>
        </div>
        <!-- <div class="activityPriceBox">
            <div v-if="study.specs && study.specs.length > 0" class="left">
                <div
                    class="gg-price-box"
                    v-for="item in study.specs"
                    :key="item.id"
                >
                    <span class="price">￥ {{ item.price }} </span>-
                    <span class="days">{{ item.days }}天</span>
                </div>
            </div>

            <div class="left" v-else>
                <div class="priceBox">
                    <div class="sale_price">
                        <span>￥</span>
                        <span>{{ study.price }}</span>
                    </div>
                    <div
                        class="origin_price"
                        :class="{ active: showSeckillPrice }"
                    >
                        <span>￥{{ study.originalPrice }}</span>
                    </div>
                </div>
                <div class="join_num" :class="{ active: showSeckillPrice }">
                    {{ study.saleInfo && study.saleInfo.buyInfo }}
                </div>
            </div>
            <div class="right" :class="{ active: showSeckillPrice }">
                <div class="endTimeTitle">优惠结束时间：</div>
                <div class="endTime">
                    {{ study.saleInfo && study.saleInfo.endTime }}
                </div>
            </div>
        </div> -->
        <div class="youhui_taocan" v-if="zuhe.length > 0">
            <div class="title">
                {{ zuhe.length > 0 ? "优惠合集" : "购买内容" }}
            </div>
            <div class="list">
                <div
                    @click="
                        sel_taocan(
                            item.id,
                            item.price,
                            item.type,
                            item.bothPrice,
                            item,
                        )
                    "
                    class="item"
                    :class="[sel_id == item.id ? 'active' : '']"
                    v-for="item in zuhe"
                    :key="item.id"
                >
                    <div class="checked"></div>
                    <div class="name">{{ item.title }}</div>
                    <div
                        class="child"
                        v-for="child in item.list"
                        :key="child.id"
                    >
                        <span>{{ child.title }}</span>
                    </div>
                    <div class="price">￥{{ item.price }}</div>
                </div>

                <!-- <div
                    @click="
                        sel_taocan(
                            study.id,
                            study.price,
                            'SINGLE',
                            study.originalPrice,
                            study,
                        )
                    "
                    class="item"
                    :class="[sel_id == study.id ? 'active' : '']"
                >
                    <div class="checked"></div>
                    <div class="name">单集</div>
                    <span class="child">{{ study.title }}</span>
                    <div class="price">￥{{ study.price }}</div>
                </div> -->
            </div>
        </div>
        <div class="tabBox">
            <div
                class="tabs"
                :class="[
                    type != 'STUDY' || episodes.length <= 0
                        ? 'flex-center'
                        : '',
                ]"
            >
                <div
                    class="tab"
                    @click="changeTab(0)"
                    :class="[tabIndex == 0 ? 'active' : '']"
                    v-if="type == 'STUDY' && episodes.length > 0"
                >
                    节目
                </div>
                <div
                    class="tab"
                    @click="changeTab(1)"
                    :class="[tabIndex == 1 ? 'active' : '']"
                >
                    介绍
                </div>
                <div
                    class="tab"
                    @click="changeTab(2)"
                    :class="[tabIndex == 2 ? 'active' : '']"
                    v-if="study.openComment"
                >
                    评论
                </div>
            </div>
            <div class="tabContents">
                <div
                    class="tabContent tabContent0"
                    :class="[tabIndex == 0 ? 'active' : '']"
                >
                    <div class="notice" v-if="study.trySeeTime > 0">
                        <span>
                            收费课程可以免费学习前{{ study.trySeeTime }}分钟
                        </span>
                    </div>
                    <div class="list">
                        <div
                            class="item"
                            v-for="item in episodes"
                            :key="item.id"
                        >
                            <div class="top">
                                <div class="left">
                                    <span v-if="item.showIndex" class="index"
                                        >第{{ item.myIndex }}集</span
                                    >
                                    <span class="title">{{ item.title }}</span>
                                </div>
                                <div
                                    class="right"
                                    @click="goVideoCourse(item, study)"
                                >
                                    <template v-if="item.type !== 'ARTICLE'">
                                        <img
                                            v-if="item.ifFree"
                                            class="player"
                                            src="~@/assets/free-player.png"
                                            alt=""
                                        />
                                        <img
                                            v-else-if="
                                                (!item.ifFree &&
                                                    (study.trySeeTime > 0 ||
                                                        item.trySeeTime > 0)) ||
                                                    item.openSell ||
                                                    item.ifBuy
                                            "
                                            class="player"
                                            src="~@/assets/player.png"
                                            alt=""
                                        />
                                        <span
                                            v-if="item.ifFree"
                                            :class="{ free: item.ifFree }"
                                        >
                                            免费观看
                                        </span>
                                        <span
                                            v-else
                                            :class="{
                                                active:
                                                    study.trySeeTime > 0 ||
                                                    item.ifBuy ||
                                                    item.openSell,
                                            }"
                                        >
                                            {{
                                                item.link
                                                    ? "进入"
                                                    : item.ifBuy
                                                    ? "观看"
                                                    : study.trySeeTime > 0 ||
                                                      item.trySeeTime > 0
                                                    ? "试看"
                                                    : item.openSell
                                                    ? "购买单集"
                                                    : ""
                                            }}
                                        </span>
                                    </template>
                                    <template v-else>
                                        <img
                                            v-if="item.ifFree"
                                            class="player"
                                            src="~@/assets/article-free-logo.png"
                                            alt=""
                                        />
                                        <img
                                            v-else-if="
                                                (!item.ifFree &&
                                                    (study.trySeeTime > 0 ||
                                                        item.trySeeTime > 0)) ||
                                                    item.openSell ||
                                                    item.ifBuy
                                            "
                                            class="player"
                                            src="~@/assets/article-logo.png"
                                            alt=""
                                        />
                                        <span
                                            v-if="item.ifFree"
                                            :class="{ free: item.ifFree }"
                                        >
                                            免费阅读
                                        </span>
                                        <span v-else class="active">
                                            {{
                                                item.link
                                                    ? "进入"
                                                    : item.ifBuy
                                                    ? "阅读"
                                                    : item.openSell
                                                    ? "购买单集"
                                                    : ""
                                            }}
                                        </span>
                                    </template>
                                </div>
                            </div>
                            <div class="bottom">
                                <div class="left">{{ item.pubTime }}</div>
                                <div class="right">
                                    <template v-if="item['videoTime'] > 0">
                                        <img
                                            class="courseTimeLogo"
                                            src="~@/assets/course-time.png"
                                            alt=""
                                        />
                                        <span class="courseTime">
                                            {{ item["videoTime"] }}
                                        </span>
                                        <span class="line"></span>
                                    </template>
                                    <img
                                        class="courseStudentLogo"
                                        src="~@/assets/course-student.png"
                                        alt=""
                                    />
                                    <span class="courseStudentNum">
                                        {{ item.inUserNum }}人学过
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="jm-notice">—— 没有更多数据了 ——</div>
                </div>
                <div
                    class="tabContent tabContent1"
                    :class="[tabIndex == 1 ? 'active' : '']"
                >
                    <div class="intro" v-html="jianjie.describe"></div>
                </div>

                <div
                    class="tabContent tabContent2"
                    :class="[tabIndex == 2 ? 'active' : '']"
                >
                    <comment-list
                        :data="commentList"
                        :avgScore="avgScore"
                        :isClick="false"
                        @update="getCommentList()"
                    ></comment-list>
                </div>
            </div>
        </div>

        <template v-if="type != 'EVENING_PAPER'">
            <div
                v-if="
                    loading &&
                        !ifBuy &&
                        study.openSell &&
                        !isGroup &&
                        study.specs.length === 0
                "
                class="joinBtn"
                @click="goPay()"
            >
                <span>
                    ￥{{ sel_price }}
                    <span
                        class="origin_price"
                        v-if="sel_both_price && sel_both_price != sel_price"
                    >
                        ￥{{ sel_both_price }}
                    </span>
                </span>
                <span>立即参加</span>
            </div>
            <div
                v-if="
                    loading &&
                        !ifBuy &&
                        study.openSell &&
                        !isGroup &&
                        study.specs.length > 0
                "
                class="joinBtn c"
                @click="goPay()"
            >
                <span>立即参加</span>
            </div>
            <div
                v-if="loading && !ifBuy && study.openSell && isGroup"
                class="joinBtn2"
            >
                <div class="left" @click="goPay()">
                    <span
                        class="origin_price"
                        v-if="sel_both_price && sel_both_price != sel_price"
                    >
                        ￥{{ sel_both_price }}
                    </span>
                    <div class="line"></div>
                    <div class="price">
                        <div>￥{{ sel_price }}</div>
                        <div class="txt">单独购买</div>
                    </div>
                </div>
                <div class="right" @click="goPintuan()">
                    <div>￥{{ groupPrice }}</div>
                    <div class="txt">发起拼团</div>
                </div>
            </div>
        </template>
        <template v-else>
            <div
                v-if="loading && !ifBuy && study.openSell"
                class="joinBtn"
                :class="[type == 'EVENING_PAPER' ? 'c' : '']"
                @click="goPay()"
            >
                <span>立即参加</span>
            </div>
        </template>
        <div
            v-if="loading && ifBuy && type != 'STUDY'"
            class="joinBtn c"
            @click="go(study)"
        >
            前往学习
        </div>
    </div>
</template>

<script>
    // import Banner from "../../assets/2.jpg";
    import CommentList from "../../components/comment-list/comment-list.vue";
    import courseService from "../../service/course.service";
    import { Dialog } from "vant";
    import scrollerMixin from "../../scroller.mixin";
    import { Toast } from "vant";
    export default {
        name: "course-detail",
        components: {
            "comment-list": CommentList,
        },
        mixins: [scrollerMixin],
        data() {
            return {
                id: "",
                type: "",
                // Banner,
                tabIndex: 0,
                study: {},
                episodes: [],
                zuhe: [],
                jianjie: {},
                commentList: [],
                avgScore: 0,
                showSeckillPrice: false,
                ifBuy: false,
                loading: false,
                sel_id: "",
                sel_price: "",
                sel_type: "",
                sel_both_price: "",
                showXufei: false,
                isGroup: false,
                groupPrice: undefined,
                link: "",
            };
        },
        mounted() {
            this.id = this.$route.params.id;
            this.type = this.$route.params.type;
            if (this.type != "STUDY") {
                this.tabIndex = 1;
            }
            if (this.id) {
                this.init();
            }
            this.getCommentList();
        },
        methods: {
            goPintuan() {
                if (this.link) {
                    location.href = this.link;
                }
            },
            sel_taocan(id, price, type, sel_both_price, obj) {
                this.sel_id = id;
                this.sel_price = price;
                this.sel_type = type;
                this.sel_both_price = sel_both_price;
                this.isGroup = obj.isGroup || false;
                this.groupPrice = obj.groupPrice || undefined;
                this.link = obj.link || "";
            },
            init() {
                courseService
                    .getStudyDetail({ id: this.id, type: this.type })
                    .then((res) => {
                        this.study = res.data.study;
                        this.episodes = res.data.episodes || [];
                        this.zuhe = res.data.zuhe;
                        this.jianjie = res.data.jianjie;
                        this.commentList = res.data.commentList || [];
                        this.avgScore = res.data.avgScore;
                        this.showXufei = res.data.showXufei;
                        if (this.type != "STUDY" || this.episodes.length <= 0) {
                            this.tabIndex = 1;
                        }
                        if (
                            this.study.saleInfo &&
                            this.study.saleInfo.endTime
                        ) {
                            this.showSeckillPrice = true;
                        }
                        this.ifBuy = res.data.ifBuy;
                        this.loading = true;
                        if (this.study.specs && this.study.specs.length > 0) {
                            this.id = this.study.specs[0].id;
                        }

                        if (this.zuhe.length == 0) {
                            this.sel_id = this.study.id;
                            this.sel_price = this.study.price;
                            this.sel_both_price = this.study.originalPrice;
                        }
                    });
            },

            getCommentList() {},
            changeTab(index) {
                this.tabIndex = index;
            },
            goVideoCourse(obj, study) {
                if (!obj.ifFree) {
                    if (!obj.ifBuy) {
                        if (study.trySeeTime <= 0 && obj.trySeeTime <= 0) {
                            if (obj.openSell) {
                                this.$router.push({
                                    path: `/pay/STUDY_EPISODE`,
                                    query: { id: obj.id },
                                });
                                return;
                            }
                        }
                    } else {
                        if (obj.link) {
                            window.location.href = obj.link;
                        } else {
                            this.$router.push({
                                path: `/video-course/${obj.id}`,
                                query: {
                                    courseId: this.id,
                                    courseType: this.type,
                                },
                            });
                        }
                    }
                } else {
                    this.$router.push({
                        path: `/video-course/${obj.id}`,
                        query: { courseId: this.id, courseType: this.type },
                    });
                }
            },
            goPay() {
                if (this.sel_id) {
                    if (this.sel_type == "zuhe") {
                        this.goPayZuhe(this.sel_id);
                    } else {
                        this.$router.push({
                            path: `/pay/${this.type}`,
                            query: { id: this.id },
                        });
                    }
                } else {
                    Toast("请选择购买内容");
                }
            },
            go(study) {
                if (!study.ifCanSee) {
                    Dialog({
                        message: `观看时间：\r ${study.playStartTime} \r ${study.playEndTime}`,
                    });
                    return;
                }
                if (this.type == "PRIVATE_RESEARCH") { 
                    this.$router.push("/private-research-handbook");
                    return;
                }
                location.href = study.learnUrl;
            },
            goPayZuhe(id) {
                this.$router.push({
                    path: "/pay/STUDY_ZUHE",
                    query: { id },
                });
            },
        },
    };
</script>

<style lang="scss" scoped src="./course-detail.scss"></style>
